import * as React from "react";
const SvgDropArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 20 20", fill: "none", stroke: "#2D2D2D", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 7.5L10 13L15 7.5", strokeWidth: 1.4, strokeLinecap: "round" }));
export default SvgDropArrow;
